import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import DefaultLayout from "../../components/DefaultLayout";
import {TextField} from 'react-md';
import {Row, Col, notification} from 'antd';
import {List, Picker, Result, Modal, Icon} from 'antd-mobile'
import { createForm } from 'rc-form';
import BottomPanel from "../../components/BottomPanel";
import ProvinceService from "../../apiServices/ProvinceService";
import DistrictService from "../../apiServices/DistrictService";
import OrderService from "../../apiServices/OrderService";
import UserService from "../../apiServices/UserService";

const alert = Modal.alert;
const nowTimeStamp = Date.now();
const now = new Date(nowTimeStamp);

class OrderAutoInfo extends Component {
    constructor(props){
        super(props);

        const urlParams = new URLSearchParams(window.location.search);
        const object_id = urlParams.get('object_id');

        this.state = {
            height: props.height,
            hasError: false,
            hiddenBtn: false,
            backToHome: false,
            insuranceType: 1,
            provinces: [],
            districts: [],
            dateOfBirth: now,
            beneficiaryDOB: now,
            full_name: '',
            beneficiary_name: '',
            gender: 1,
            social_id: '',
            beneficiary_social_id: '',
            beneficiary_phone: '',
            beneficiary_bank: '',
            bank_branch: '',
            bank_address: '',
            phone_no: '',
            address: '',
            province_id: 1,
            district_id: null,
            hasBeneficiary: 0,
            beneficiary: 1,
            order_id: null,
            object_id: object_id,
            userInfo: null,
        };
    }

    componentDidMount() {
        this.setState({height: window.innerHeight + 'px'});
        UserService.fetchMe().then(response => {this.setState({
            full_name: response.data.name,
            email: response.data.email,
            phone_no: response.data.phone,
        }) });

        if (this.state.object_id){
            OrderService.findByObjectId(this.state.object_id).then(response=>{
                this.setState({order_id: response.data.id});
            }).catch(function(error){
                console.log(error);
            });
        }else{
            this.props.history.push('/');
        }

        ProvinceService.getList().then(response => {
            this.setState({provinces: response.data});
        }).catch(function(error){
            console.log(error);
        });

        DistrictService.getList(this.state.province_id).then(response => {
            this.setState({districts: response.data});
        }).catch(function(error){
            console.log(error);
        });
    }

    formSubmit = () => {
        if (this.state.full_name===''){
            notification['error']({
                message: 'Họ và tên không được để trống',
                description: '',
            });
        }else if (this.state.social_id === ''){
            notification['error']({
                message: 'Bạn chưa nhập số CMND/Hộ chiếu',
                description: '',
            });
        }else if (this.state.phone_no === ''){
            notification['error']({
                message: 'Bạn chưa nhập số điện thoại',
                description: '',
            });
        }else if (this.state.email === ''){
            notification['error']({
                message: 'Bạn chưa nhập Email',
                description: '',
            });
        }else if (this.state.province_id == null){
            notification['error']({
                message: 'Bạn chưa chọn Tỉnh/Thành phố',
                description: '',
            });
        }else if (this.state.district_id == null){
            notification['error']({
                message: 'Bạn chưa chọn Quận/Huyện',
                description: '',
            });
        }else if (this.state.address === ''){
            notification['error']({
                message: 'Bạn chưa nhập địa chỉ',
                description: '',
            });
        }else{
            this.updateOrder();
        }
    };

    updateOrder(){
        OrderService.update({
            'order_id': this.state.order_id,
            'email': this.state.email,
            'full_name': this.state.full_name,
            'social_id': this.state.social_id,
            'phone_no': this.state.phone_no,
            'address': this.state.address,
            'province_id': this.state.province_id,
            'district_id': this.state.district_id,
        }).then(response => {
            alert('Đặt mua thành công', <div><Result
                img={<Icon type="check-circle" className="spe" style={{ fill: '#1F90E6' }} />}
                title="Cảm ơn bạn đã đăng ký mua bảo hiểm"
                message="Hồ sơ bảo hiểm của bạn sẽ được duyệt trong vòng 5 phút"
            /></div>, [
                { text: 'Trang chủ', onPress: () => this.props.history.push('/') },
                { text: 'Bổ sung hồ sơ', onPress: () => this.props.history.push('/hoan-thien-ho-so?object_id='+this.state.object_id) },
            ]);
        }).catch(error => {
            notification.error({
                message: 'Lỗi lưu thông tin',
                description: JSON.stringify(error),
            });
        });
    }

    provinceChange = (e) => {
        this.setState({province_id: e[0]});
        DistrictService.getList(parseInt(e[0])).then(response => {
            this.setState({districts: response.data});
        }).catch(function(error){
            console.log(error);
        });
    };

    render() {
        const { getFieldProps } = this.props.form;

        return (
            <div className='App-block bgWhite' style={{minHeight: this.state.height}}>
                <DefaultLayout {...this.props} showHome={true} title="Thông tin bên mua Bảo hiểm" classNameContent="bgWhite" page_type={1} hiddenFt={true} showBottomPanel={true}>
                    <div className="wrap-content" style={{marginBottom: '50px'}}>
                        <TextField
                            id="full_name"
                            label="Họ và tên"
                            lineDirection="center"
                            placeholder=""
                            value={this.state.full_name}
                            className="md-cell md-cell--12"
                            onChange={e => this.setState({full_name: e})}
                        />

                        <Row gutter={24} style={{margin: 0}}>
                            <Col span={12} style={{padding: '0'}}>
                                <TextField
                                    id="social_id"
                                    label="CMND/Hộ chiếu"
                                    lineDirection="center"
                                    placeholder=""
                                    className="md-cell md-cell--12"
                                    onChange={e => this.setState({social_id: e})}
                                />
                            </Col>
                            <Col span={12} style={{textAlign: 'right', padding: 0}}>
                                <TextField
                                    id="phone_no"
                                    label="Số điện thoại"
                                    lineDirection="center"
                                    placeholder=""
                                    type='number'
                                    className="md-cell md-cell--12"
                                    value={this.state.phone_no}
                                    onChange={e => this.setState({phone_no: e})}
                                />
                            </Col>
                        </Row>

                        <TextField
                            id="email"
                            label="Email"
                            lineDirection="center"
                            placeholder=""
                            type='email'
                            className="md-cell md-cell--12"
                            value={this.state.email}
                            onChange={e => this.setState({email: e})}
                        />

                        <Row gutter={24} style={{margin: 0}}>
                            <Col span={12} style={{padding: '0'}}>
                                <Picker extra='Chọn' data={this.state.provinces} cols={1} {...getFieldProps('province_id')}
                                    onOk={this.provinceChange}
                                    okText="OK"
                                    dismissText="Hủy"
                                    title="Tỉnh/Thành phố"
                                    value={[this.state.province_id]}
                                >
                                    <List.Item wrap arrow="horizontal">Tỉnh/Thành phố: </List.Item>
                                </Picker>
                            </Col>
                            <Col span={12} style={{textAlign: 'right', padding: 0}}>
                                <Picker extra='Chọn' data={this.state.districts} cols={1} {...getFieldProps('district_id')}
                                    onOk={e => this.setState({district_id: e[0]})}
                                    okText="OK"
                                    dismissText="Hủy"
                                    title="Quận/Huyện"
                                >
                                    <List.Item wrap arrow="horizontal">Quận/Huyện: </List.Item>
                                </Picker>
                            </Col>
                        </Row>

                        <TextField
                            id="address"
                            label="Địa chỉ"
                            lineDirection="center"
                            placeholder=""
                            type='text'
                            className="md-cell md-cell--12"
                            onChange={e => this.setState({address: e})}
                        />

                    </div>

                </DefaultLayout>
                <BottomPanel handleClick={this.formSubmit} hidden={this.state.hiddenBtn} title={"Tiếp tục"} actionType='submit' actionContent={'thong-tin-doi-tuong'}/>
            </div>
        )
    }
}

OrderAutoInfo = createForm()(OrderAutoInfo);

export default (withTranslation())(OrderAutoInfo);